/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AppsRouteImport } from './routes/apps'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as GnocchiRouteImport } from './routes/gnocchi'
import { Route as JoinRouteImport } from './routes/join'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PlanRouteImport } from './routes/plan'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReturnToAppRouteImport } from './routes/return-to-app'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as TosRouteImport } from './routes/tos'
import { Route as TripTickRouteImport } from './routes/trip-tick'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminChangelogsRouteImport } from './routes/admin/changelogs'
import { Route as AdminFoodCategoriesRouteImport } from './routes/admin/foodCategories'
import { Route as AdminFoodsRouteImport } from './routes/admin/foods'
import { Route as AdminPlansRouteImport } from './routes/admin/plans'
import { Route as InviteCodeRouteImport } from './routes/invite/$code'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsRoute = AppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const GnocchiRoute = GnocchiRouteImport.update({
  id: '/gnocchi',
  path: '/gnocchi',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanRoute = PlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ReturnToAppRoute = ReturnToAppRouteImport.update({
  id: '/return-to-app',
  path: '/return-to-app',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const TosRoute = TosRouteImport.update({
  id: '/tos',
  path: '/tos',
  getParentRoute: () => rootRouteImport,
} as any)
const TripTickRoute = TripTickRouteImport.update({
  id: '/trip-tick',
  path: '/trip-tick',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminChangelogsRoute = AdminChangelogsRouteImport.update({
  id: '/changelogs',
  path: '/changelogs',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFoodCategoriesRoute = AdminFoodCategoriesRouteImport.update({
  id: '/foodCategories',
  path: '/foodCategories',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFoodsRoute = AdminFoodsRouteImport.update({
  id: '/foods',
  path: '/foods',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPlansRoute = AdminPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AdminRouteRoute,
} as any)
const InviteCodeRoute = InviteCodeRouteImport.update({
  id: '/invite/$code',
  path: '/invite/$code',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/apps': typeof AppsRoute
  '/contact': typeof ContactRoute
  '/gnocchi': typeof GnocchiRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/plan': typeof PlanRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/return-to-app': typeof ReturnToAppRoute
  '/settings': typeof SettingsRoute
  '/tos': typeof TosRoute
  '/trip-tick': typeof TripTickRoute
  '/verify': typeof VerifyRoute
  '/admin/changelogs': typeof AdminChangelogsRoute
  '/admin/foodCategories': typeof AdminFoodCategoriesRoute
  '/admin/foods': typeof AdminFoodsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/invite/$code': typeof InviteCodeRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/apps': typeof AppsRoute
  '/contact': typeof ContactRoute
  '/gnocchi': typeof GnocchiRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/plan': typeof PlanRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/return-to-app': typeof ReturnToAppRoute
  '/settings': typeof SettingsRoute
  '/tos': typeof TosRoute
  '/trip-tick': typeof TripTickRoute
  '/verify': typeof VerifyRoute
  '/admin/changelogs': typeof AdminChangelogsRoute
  '/admin/foodCategories': typeof AdminFoodCategoriesRoute
  '/admin/foods': typeof AdminFoodsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/invite/$code': typeof InviteCodeRoute
  '/admin': typeof AdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/apps': typeof AppsRoute
  '/contact': typeof ContactRoute
  '/gnocchi': typeof GnocchiRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/plan': typeof PlanRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/return-to-app': typeof ReturnToAppRoute
  '/settings': typeof SettingsRoute
  '/tos': typeof TosRoute
  '/trip-tick': typeof TripTickRoute
  '/verify': typeof VerifyRoute
  '/admin/changelogs': typeof AdminChangelogsRoute
  '/admin/foodCategories': typeof AdminFoodCategoriesRoute
  '/admin/foods': typeof AdminFoodsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/invite/$code': typeof InviteCodeRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/about'
    | '/apps'
    | '/contact'
    | '/gnocchi'
    | '/join'
    | '/login'
    | '/plan'
    | '/privacy'
    | '/reset-password'
    | '/return-to-app'
    | '/settings'
    | '/tos'
    | '/trip-tick'
    | '/verify'
    | '/admin/changelogs'
    | '/admin/foodCategories'
    | '/admin/foods'
    | '/admin/plans'
    | '/invite/$code'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/apps'
    | '/contact'
    | '/gnocchi'
    | '/join'
    | '/login'
    | '/plan'
    | '/privacy'
    | '/reset-password'
    | '/return-to-app'
    | '/settings'
    | '/tos'
    | '/trip-tick'
    | '/verify'
    | '/admin/changelogs'
    | '/admin/foodCategories'
    | '/admin/foods'
    | '/admin/plans'
    | '/invite/$code'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/about'
    | '/apps'
    | '/contact'
    | '/gnocchi'
    | '/join'
    | '/login'
    | '/plan'
    | '/privacy'
    | '/reset-password'
    | '/return-to-app'
    | '/settings'
    | '/tos'
    | '/trip-tick'
    | '/verify'
    | '/admin/changelogs'
    | '/admin/foodCategories'
    | '/admin/foods'
    | '/admin/plans'
    | '/invite/$code'
    | '/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  AppsRoute: typeof AppsRoute
  ContactRoute: typeof ContactRoute
  GnocchiRoute: typeof GnocchiRoute
  JoinRoute: typeof JoinRoute
  LoginRoute: typeof LoginRoute
  PlanRoute: typeof PlanRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ReturnToAppRoute: typeof ReturnToAppRoute
  SettingsRoute: typeof SettingsRoute
  TosRoute: typeof TosRoute
  TripTickRoute: typeof TripTickRoute
  VerifyRoute: typeof VerifyRoute
  InviteCodeRoute: typeof InviteCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps': {
      id: '/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AppsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gnocchi': {
      id: '/gnocchi'
      path: '/gnocchi'
      fullPath: '/gnocchi'
      preLoaderRoute: typeof GnocchiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan': {
      id: '/plan'
      path: '/plan'
      fullPath: '/plan'
      preLoaderRoute: typeof PlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/return-to-app': {
      id: '/return-to-app'
      path: '/return-to-app'
      fullPath: '/return-to-app'
      preLoaderRoute: typeof ReturnToAppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tos': {
      id: '/tos'
      path: '/tos'
      fullPath: '/tos'
      preLoaderRoute: typeof TosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip-tick': {
      id: '/trip-tick'
      path: '/trip-tick'
      fullPath: '/trip-tick'
      preLoaderRoute: typeof TripTickRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/changelogs': {
      id: '/admin/changelogs'
      path: '/changelogs'
      fullPath: '/admin/changelogs'
      preLoaderRoute: typeof AdminChangelogsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/foodCategories': {
      id: '/admin/foodCategories'
      path: '/foodCategories'
      fullPath: '/admin/foodCategories'
      preLoaderRoute: typeof AdminFoodCategoriesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/foods': {
      id: '/admin/foods'
      path: '/foods'
      fullPath: '/admin/foods'
      preLoaderRoute: typeof AdminFoodsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/plans': {
      id: '/admin/plans'
      path: '/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AdminPlansRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/invite/$code': {
      id: '/invite/$code'
      path: '/invite/$code'
      fullPath: '/invite/$code'
      preLoaderRoute: typeof InviteCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteRouteChildren {
  AdminChangelogsRoute: typeof AdminChangelogsRoute
  AdminFoodCategoriesRoute: typeof AdminFoodCategoriesRoute
  AdminFoodsRoute: typeof AdminFoodsRoute
  AdminPlansRoute: typeof AdminPlansRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminChangelogsRoute: AdminChangelogsRoute,
  AdminFoodCategoriesRoute: AdminFoodCategoriesRoute,
  AdminFoodsRoute: AdminFoodsRoute,
  AdminPlansRoute: AdminPlansRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  AppsRoute: AppsRoute,
  ContactRoute: ContactRoute,
  GnocchiRoute: GnocchiRoute,
  JoinRoute: JoinRoute,
  LoginRoute: LoginRoute,
  PlanRoute: PlanRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ReturnToAppRoute: ReturnToAppRoute,
  SettingsRoute: SettingsRoute,
  TosRoute: TosRoute,
  TripTickRoute: TripTickRoute,
  VerifyRoute: VerifyRoute,
  InviteCodeRoute: InviteCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
